  // ─────────── Slideshow (horizontal translate, seamless loop) ───────────
  //
  // Filmstrip = 6 slides (ABCABC). Each step translates by one slide-width:
  //   desktop  → 33.333vw (three images visible at once)
  //   mobile   → 100vw    (one image visible at a time)
  // After 3 advances the strip sits at a visually-identical position to origin,
  // so we snap it back with no transition and keep panning forward forever.
  (function () {
    const strip = document.getElementById('slides');
    const dots  = document.querySelectorAll('#dots .dot');
    const hero  = document.getElementById('hero');
    // Only the home page has a #hero slideshow. On PDP and other pages,
    // bail early so subsequent IIFEs in this file still run.
    if (!strip || !hero) return;
    const SLIDES = 3;               // logical slide count
    // HOLD read from data-hold on #slides (set by the Shopify section).
    // Falls back to 3500ms, clamped to a safe minimum of 1500ms.
    const HOLD = Math.max(1500, parseInt(strip && strip.dataset.hold, 10) || 3500);
    const TRANSITION = 1100;        // ms (matches CSS)
    const MOBILE_BP = 820;
    let position = 0;               // 0..SLIDES (SLIDES == clone of 0)
    let animating = false;
    let timer;

    function stepVw() {
      return window.innerWidth > MOBILE_BP ? (100 / 3) : 100;
    }

    function setDots(i) {
      dots.forEach((d, k) => d.classList.toggle('active', k === i));
    }

    function translateTo(pos, withTransition) {
      strip.classList.toggle('no-transition', !withTransition);
      if (!withTransition) void strip.offsetWidth; // flush style so next change animates
      strip.style.transform = `translateX(-${pos * stepVw()}vw)`;
    }

    function advance() {
      if (animating) return;
      animating = true;
      const nextPos = position + 1;
      const nextLogical = nextPos % SLIDES;

      translateTo(nextPos, true);
      setDots(nextLogical);

      setTimeout(() => {
        if (nextPos === SLIDES) {
          // Clone position — silently rewind to origin; visually identical.
          translateTo(0, false);
          position = 0;
        } else {
          position = nextPos;
        }
        animating = false;
      }, TRANSITION + 20);
    }

    function jumpTo(targetLogical) {
      if (animating || targetLogical === (position % SLIDES)) return;
      animating = true;
      translateTo(targetLogical, true);
      setDots(targetLogical);
      setTimeout(() => {
        position = targetLogical;
        animating = false;
      }, TRANSITION + 20);
    }

    function start() {
      stop();
      timer = setInterval(advance, HOLD + TRANSITION);
    }
    function stop() { if (timer) clearInterval(timer); }

    // Re-apply current transform when viewport crosses the breakpoint
    window.addEventListener('resize', () => translateTo(position, false));

    dots.forEach(d => d.addEventListener('click', () => {
      jumpTo(parseInt(d.dataset.i, 10));
      start();
    }));

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    setDots(0);
    start();
  })();

  // ─────────── Announcement bar (dismissible, persisted) ───────────
  (function () {
    const bar = document.getElementById('announcement');
    const btn = document.getElementById('announcement-close');
    if (!bar || !btn) return;
    const KEY = 'levain-announcement-dismissed';

    try {
      if (localStorage.getItem(KEY) === '1') {
        // Apply without transition on first paint
        bar.style.transition = 'none';
        bar.classList.add('dismissed');
        document.body.classList.add('no-announcement');
        // Restore transition on next frame
        requestAnimationFrame(() => { bar.style.transition = ''; });
      }
    } catch (e) { /* localStorage unavailable — no-op */ }

    btn.addEventListener('click', () => {
      bar.classList.add('dismissed');
      document.body.classList.add('no-announcement');
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    });
  })();

  // ─────────── Announcement bar · auto-hide on scroll ───────────
  // Hides the top announcement strip once the user scrolls past a small
  // threshold, regardless of which page we're on. Runs on every page.
  (function () {
    const bar = document.getElementById('announcement');
    if (!bar) return;
    const THRESHOLD = 80;
    function onScroll() {
      if (window.scrollY > THRESHOLD) {
        document.body.classList.add('announcement-hidden');
      } else {
        document.body.classList.remove('announcement-hidden');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  // ─────────── Nav scroll state ───────────
  (function () {
    const nav = document.getElementById('nav');
    const hero = document.getElementById('hero');
    if (!nav || !hero) return;
    function onScroll() {
      const threshold = hero.offsetHeight - 80;
      if (window.scrollY > threshold) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  // ─────────── Reveal on scroll ───────────
  (function () {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  })();

  // ─────────── Nav · cart count bubble updater ───────────
  // Exposes window.levainUpdateCartCount() — called by any client-side
  // add-to-cart flow to refresh the badge without a page reload.
  (function () {
    async function update() {
      const badge = document.querySelector('[data-nav-cart-count]');
      if (!badge) return;
      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const cart = await res.json();
        const n = cart.item_count || 0;
        badge.textContent = n;
        badge.hidden = n === 0;
        // Small bump animation so the update is visible
        badge.classList.remove('is-bumped');
        void badge.offsetWidth;
        badge.classList.add('is-bumped');
        setTimeout(() => badge.classList.remove('is-bumped'), 240);
      } catch (e) { /* network issue — leave previous value in place */ }
    }
    window.levainUpdateCartCount = update;
  })();

  // ─────────── PDP · AJAX add-to-cart with brief confirmation ───────────
  (function () {
    const form = document.getElementById('pdp-form');
    if (!form) return;
    const btn = form.querySelector('.pdp-cta');
    const label = form.querySelector('.pdp-cta-label');
    if (!btn || !label) return;
    const originalText = label.textContent;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      label.textContent = 'Adding…';

      try {
        const res = await fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root + 'cart/add.js' || '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });

        if (!res.ok) throw new Error('HTTP ' + res.status);

        btn.classList.add('is-added');
        label.textContent = 'Added ✓';
        // Refresh the nav cart count bubble
        if (window.levainUpdateCartCount) window.levainUpdateCartCount();
        // Refresh cart drawer / count if Dawn's pubsub is loaded
        if (window.PUB_SUB_EVENTS && window.publish) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pdp-form' });
        }
        setTimeout(() => {
          btn.classList.remove('is-added');
          label.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      } catch (err) {
        label.textContent = 'Error — try again';
        setTimeout(() => {
          label.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      }
    });
  })();

  // ─────────── PDP · mobile image slider dots + arrows ───────────
  // Builds prev arrow + dot cluster + next arrow. Active dot tracks the
  // currently-visible slide; arrows nudge the scroll by one slide width.
  (function () {
    const track = document.querySelector('.pdp-left');
    const host = document.querySelector('[data-pdp-dots]');
    if (!track || !host) return;
    const slides = track.querySelectorAll('.pdp-image');
    if (slides.length < 2) return;

    let active = 0;
    // Use track.scrollTo({ left }) instead of slides[i].scrollIntoView() —
    // scrollIntoView walks up the ancestor chain and can end up scrolling
    // the <body> horizontally (making the whole page "wider") even with
    // body { overflow-x: hidden }. scrollLeft on the slider stays scoped.
    const scrollTo = (i) => {
      const clamped = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
    };

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'pdp-dots-arrow';
    prev.setAttribute('aria-label', 'Previous image');
    prev.textContent = '‹';
    prev.addEventListener('click', () => scrollTo(active - 1));

    const list = document.createElement('div');
    list.className = 'pdp-dots-list';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'pdp-dots-arrow';
    next.setAttribute('aria-label', 'Next image');
    next.textContent = '›';
    next.addEventListener('click', () => scrollTo(active + 1));

    slides.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Go to image ${i + 1}`);
      b.addEventListener('click', () => scrollTo(i));
      list.appendChild(b);
    });

    host.appendChild(prev);
    host.appendChild(list);
    host.appendChild(next);

    const dots = list.querySelectorAll('button');
    const setActive = (idx) => {
      active = idx;
      dots.forEach((d, k) => d.classList.toggle('is-active', k === idx));
      prev.disabled = idx === 0;
      next.disabled = idx === slides.length - 1;
    };
    setActive(0);
    // Safari can restore a saved scrollLeft from bfcache on back/forward
    // navigation. Reset to the first slide on first paint so the user
    // always starts at image 1.
    track.scrollLeft = 0;

    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting && e.intersectionRatio >= 0.55) {
          const idx = [...slides].indexOf(e.target);
          if (idx >= 0) setActive(idx);
        }
      });
    }, { root: track, threshold: [0.55, 0.9] });
    slides.forEach(s => io.observe(s));
  })();

  // ─────────── PDP · Description/Details/Material tabs ───────────
  // Event delegation on the group — robust against re-renders and keeps a
  // single listener for all three buttons.
  (function () {
    const group = document.querySelector('.pdp-info[data-pdp-tabs]');
    if (!group) return;
    group.addEventListener('click', (e) => {
      const tab = e.target.closest('.pdp-info-tab');
      if (!tab || !group.contains(tab)) return;
      const idx = tab.dataset.tab;
      group.querySelectorAll('.pdp-info-tab').forEach(t => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-expanded', active ? 'true' : 'false');
      });
      group.querySelectorAll('.pdp-info-panel').forEach(p => {
        p.classList.toggle('is-open', p.dataset.panel === idx);
      });
    });
  })();

  // ─────────── Nav drawer (hamburger → slide-in menu) ───────────
  (function () {
    const toggle = document.getElementById('nav-menu-toggle');
    const drawer = document.getElementById('nav-drawer');
    const closeBtn = document.getElementById('nav-drawer-close');
    const backdrop = document.getElementById('nav-drawer-backdrop');
    if (!toggle || !drawer) return;

    function open() {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    closeBtn && closeBtn.addEventListener('click', close);
    backdrop && backdrop.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });
  })();
